"use strict";
"use es6";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getSymbolObservable = getSymbolObservable;
exports.$$observable = exports.observable = void 0;

var _root = require("../util/root");

function getSymbolObservable(context) {
  var $$observable;
  var _Symbol = context.Symbol;

  if (typeof _Symbol === 'function') {
    if (_Symbol.observable) {
      $$observable = _Symbol.observable;
    } else {
      $$observable = _Symbol('observable');
      _Symbol.observable = $$observable;
    }
  } else {
    $$observable = '@@observable';
  }

  return $$observable;
}

var observable = getSymbolObservable(_root.root);
/**
 * @deprecated use observable instead
 */

exports.observable = observable;
var $$observable = observable;
exports.$$observable = $$observable;